module.exports = __webpack_public_path__ + "media/images/emp-logo-90df133ea1998ab4165409a307dbd7c4.png";